import clock from "../../images/icons/location/clock.svg";
import location from "../../images/icons/location/location.svg";
import tel from "../../images/icons/location/tel.svg";

export default function Location() {
  return (
    <div className="container">
      <ul className="location">
        <li className="location__item">
          <div className="location__item--img">
            <img src={clock} alt="clock" />
          </div>
          <div className="location__item--desc">
            <p>Час роботи:</p>
            <p>8.00-22.00</p>
          </div>
        </li>

        <li className="location__item">
          <div className="location__item--img">
            <img src={location} alt="location" />
          </div>
          <div className="location__item--desc">
            <p>Наша адреса:</p>
            <p>м.Кам'янець-Подільський, вул.Данила Галицького 20</p>
          </div>
        </li>

        <li className="location__item">
          <div className="location__item--img">
            <img src={tel} alt="phone" />
          </div>
          <div className="location__item--desc">
            <p>Номер телефону:</p>
            <p>+38 (067) 0 777 332</p>
          </div>
        </li>
      </ul>
    </div>
  );
}
